import { createContext, useContext } from 'react';

const NotificationsContext = createContext<any>(undefined);

export const useNotificationsContext = () => useContext(NotificationsContext);
export default NotificationsContext;
